import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.4944 10.1414L13.0844 7.56144L14.4944 8.97144L9.49438 13.9714L4.49439 8.97144L5.90439 7.56144L8.49438 10.1414V0.471436H10.4944V10.1414Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.4944 9.47144V16.4714H2.49438V9.47144H0.494385V16.4714C0.494385 17.5714 1.39438 18.4714 2.49438 18.4714H16.4944C17.5944 18.4714 18.4944 17.5714 18.4944 16.4714V9.47144H16.4944Z",
		fill: "currentColor"
	})]
});
export default SvgImportIcon;
